import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-70" data-mp="1hecojq9i41mx">
      <div className="mx-auto max-w-3xl px-4" data-id="element-71" data-mp="1cf9ko959c1gj">
        <p className="mb-3 text-center text-xs font-extrabold uppercase tracking-[.18em] text-earth" data-id="element-72" data-mp="1cgb5h5c2s2bg">Resolvemos tus dudas</p>
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-field md:text-4xl" data-id="element-73" data-mp="2535py28w71ox">Preguntas frecuentes</h2>
        <div className="mt-10 space-y-3" data-id="element-74" data-mp="20319gc7zi6yp">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-lg border border-line bg-cream" data-id="element-75" data-mp="1v7c4tuh3xzvj" data-mpi={index}>
                <h3 className="font-sans" data-id="element-76" data-mp="jpsvrlguj2p2">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-77" data-mp="jorirbg9s64p">
                    <span data-id="element-78" data-mp="1aq2em1hh2y7l">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-earth transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-79" data-mp="1apar7dy146se" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-80" data-mp="11ve704ofd4fm">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-81" data-mp="16oqto99jn15q">
                      <p className="border-t border-line px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-82" data-mp="mywv9ccbpnsj">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}